import { createAsyncAction, createStandardAction } from 'typesafe-actions'
import {
  MerchantInitReq,
  MerchantInitRes,
  MerchantCreatePackageReq,
  ActionRes,
  StaffListReq,
  StaffListRes,
  CreateStaffReq,
  StaffRolesReq,
  StaffRolesRes,
  StaffDetailReq,
  StaffDetailRes,
  UpdateStaffReq,
  DeleteStaffReq,
  ResetPinReq,
  MerchantPackageListReq,
  MerchantPackageListRes,
  PackagesSpecReq,
  PackagesSpecRes,
  PackagesSpecByIDReq,
  PackagesSpecByIDRes,
  PackagesRegisReq,
  ActivateReq,
  StaffStatusReq,
  PackageLogReq,
  PackageLogRes,
  CheckPackageReq,
  CheckPackageRes,
  GetConfigReq,
  GetConfigRes,
  SetConfigReq,
  SetConfigRes,
  GetConfigListReq,
  GetConfigListRes,
  PaymentConfigReq,
  GetPaymentConfigReq,
  GetPaymentConfigRes,
} from './types'

export const getMerchantInitAction = createAsyncAction(
  'POS/GET_MERCHANT_INIT_REQ',
  'POS/GET_MERCHANT_INIT_SUCCESS',
  'POS/GET_MERCHANT_INIT_FAILURE',
)<MerchantInitReq, MerchantInitRes, Error>()

export const MerchantCreatePackageAction = createAsyncAction(
  'POS/MERCHANT_CREATE_PACKAGE_REQ',
  'POS/MERCHANT_CREATE_PACKAGE_SUCCESS',
  'POS/MERCHANT_CREATE_PACKAGE_FAILURE',
)<MerchantCreatePackageReq, ActionRes, Error>()

export const getStaffListAction = createAsyncAction(
  'POS/GET_STAFF_LIST_REQ',
  'POS/GET_STAFF_LIST_SUCCESS',
  'POS/GET_STAFF_LIST_FAILURE',
)<StaffListReq, StaffListRes, Error>()

export const getRolesListAction = createAsyncAction(
  'POS/GET_ROLES_LIST_REQ',
  'POS/GET_ROLES_LIST_SUCCESS',
  'POS/GET_ROLES_LIST_FAILURE',
)<StaffRolesReq, StaffRolesRes, Error>()

export const getDetailAction = createAsyncAction(
  'POS/GET_STAFF_DETAIL_REQ',
  'POS/GET_STAFF_DETAIL_SUCCESS',
  'POS/GET_STAFF_DETAIL_FAILURE',
)<StaffDetailReq, StaffDetailRes, Error>()

export const createAction = createAsyncAction(
  'POS/CREATE_STAFF_REQ',
  'POS/CREATE_STAFF_SUCCESS',
  'POS/CREATE_STAFF_FAILURE',
)<CreateStaffReq, ActionRes, Error>()

export const updateAction = createAsyncAction(
  'POS/UPDATE_STAFF_REQ',
  'POS/UPDATE_STAFF_SUCCESS',
  'POS/UPDATE_STAFF_FAILURE',
)<UpdateStaffReq, ActionRes, Error>()

export const resetPinAction = createAsyncAction(
  'POS/RESET_STAFF_PIN_REQ',
  'POS/RESET_STAFF_PIN_SUCCESS',
  'POS/RESET_STAFF_PIN_FAILURE',
)<ResetPinReq, ActionRes, Error>()

export const deleteAction = createAsyncAction(
  'POS/DELETE_STAFF_REQ',
  'POS/DELETE_STAFF_SUCCESS',
  'POS/DELETE_STAFF_FAILURE',
)<DeleteStaffReq, ActionRes, Error>()

export const updateStaffStatusAction = createAsyncAction(
  'POS/UPDATE_STAFF_STATUS_REQ',
  'POS/UPDATE_STAFF_STATUS_SUCCESS',
  'POS/UPDATE_STAFF_STATUS_FAILURE',
)<StaffStatusReq, ActionRes, Error>()

export const getMerchantPackageListAction = createAsyncAction(
  'POS/GET_MERCHANT_PACKAGE_LIST_REQ',
  'POS/GET_MERCHANT_PACKAGE_LIST_SUCCESS',
  'POS/GET_MERCHANT_PACKAGE_LIST_FAILURE',
)<MerchantPackageListReq, MerchantPackageListRes, Error>()

export const getPackagesSpecAction = createAsyncAction(
  'POS/GET_PACKAGES_SPEC_REQ',
  'POS/GET_PACKAGES_SPEC_SUCCESS',
  'POS/GET_PACKAGES_SPEC_FAILURE',
)<PackagesSpecReq, PackagesSpecRes, Error>()

export const getPackagesSpecByIDAction = createAsyncAction(
  'POS/GET_PACKAGES_SPEC_BY_ID_REQ',
  'POS/GET_PACKAGES_SPEC_BY_ID_SUCCESS',
  'POS/GET_PACKAGES_SPEC_BY_ID_FAILURE',
)<PackagesSpecByIDReq, PackagesSpecByIDRes, Error>()

export const buyPackageAction = createAsyncAction(
  'POS/BUY_PACKAGE_REQ',
  'POS/BUY_PACKAGE_SUCCESS',
  'POS/BUY_PACKAGE_FAILURE',
)<PackagesRegisReq, ActionRes, Error>()

export const renewPackageAction = createAsyncAction(
  'POS/RENEW_PACKAGE_REQ',
  'POS/RENEW_PACKAGE_SUCCESS',
  'POS/RENEW_PACKAGE_FAILURE',
)<PackagesRegisReq, ActionRes, Error>()

export const activatePackageAction = createAsyncAction(
  'POS/ACTIVATE_PACKAGE_REQ',
  'POS/ACTIVATE_PACKAGE_SUCCESS',
  'POS/ACTIVATE_PACKAGE_FAILURE',
)<ActivateReq, ActionRes, Error>()

export const getPackagesLogAction = createAsyncAction(
  'POS/GET_PACKAGES_LOGS_REQ',
  'POS/GET_PACKAGES_LOGS_SUCCESS',
  'POS/GET_PACKAGES_LOGS_FAILURE',
)<PackageLogReq, PackageLogRes, Error>()

export const checkMerchantPackageAction = createAsyncAction(
  'POS/CHECK_MERCHANT_PACKAGE_REQ',
  'POS/CHECK_MERCHANT_PACKAGE_SUCCESS',
  'POS/CHECK_MERCHANT_PACKAGE_FAILURE',
)<CheckPackageReq, CheckPackageRes, Error>()

export const getConfigAction = createAsyncAction(
  'POS/GET_CONFIG_REQ',
  'POS/GET_CONFIG_SUCCESS',
  'POS/GET_CONFIG_FAILURE',
)<GetConfigReq, GetConfigRes, Error>()

export const setConfigAction = createAsyncAction(
  'POS/UPDATE_CONFIG_REQ',
  'POS/UPDATE_CONFIG_SUCCESS',
  'POS/UPDATE_CONFIG_FAILURE',
)<SetConfigReq, SetConfigRes, Error>()

export const getConfigListAction = createAsyncAction(
  'POS/GET_CONFIGS_LIST_REQ',
  'POS/GET_CONFIGS_LIST_SUCCESS',
  'POS/GET_CONFIGS_LIST_FAILURE',
)<GetConfigListReq, GetConfigListRes, Error>()

export const setPaymentConfigAction = createAsyncAction(
  'POS/UPDATE_PAYMENT_CONFIG_REQ',
  'POS/UPDATE_PAYMENT_CONFIG_SUCCESS',
  'POS/UPDATE_PAYMENT_CONFIG_FAILURE',
)<PaymentConfigReq, ActionRes, Error>()

export const getPaymentConfigListAction = createAsyncAction(
  'POS/GET_CONFIGS_PAYMENT_LIST_REQ',
  'POS/GET_CONFIGS_PAYMENT_LIST_SUCCESS',
  'POS/GET_CONFIGS_PAYMENT_LIST_FAILURE',
)<GetPaymentConfigReq, GetPaymentConfigRes, Error>()

export const clearEventAction = createStandardAction('POS/CLEAR_EVENT')<void>()
